// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jsbngBwkIPi9aGe0WAyg{padding:0 8px 16px}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationList/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".wrap {\n  padding: 0 8px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jsbngBwkIPi9aGe0WAyg`
};
export default ___CSS_LOADER_EXPORT___;
